<template>
    <section class="monitoringLogs">
        <label>Logs</label>
        <ul>
          <log is="log" v-for="(log, index) in logs" :key="index" :data="log"></log>
        </ul>
    </section>
</template>

<script>
import Log from '@/components/monitoring/Log'
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('Logs')

export default {
  computed: {
    ...mapState({
      logs: state => { return state.logs }
    })
  },
  components: { Log }
}
</script>

<style>
.monitoringLogs{
  flex: 1 1 auto;
  overflow-y: auto;
  height: 100%;
}
.monitoringLogs ul{
  margin:0;
  padding:0;
}
</style>
